"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFitnessGoal = void 0;
var IFitnessGoal;
(function (IFitnessGoal) {
    IFitnessGoal["Performance"] = "performance";
    IFitnessGoal["Leanandtone"] = "leanandtone";
    IFitnessGoal["Strengthandpower"] = "strengthandpower";
    IFitnessGoal["Weightloss"] = "weightloss";
    IFitnessGoal["Happyandhealthy"] = "happyandhealthy";
    IFitnessGoal["Healthandwellness"] = "healthandwellness";
    IFitnessGoal["Pregnant"] = "pregnant";
    IFitnessGoal["Postpregnancy"] = "postpregnancy";
    IFitnessGoal["Train"] = "train";
})(IFitnessGoal || (exports.IFitnessGoal = IFitnessGoal = {}));
//# sourceMappingURL=fitness-goal.js.map